import React from 'react';
import { Users } from 'lucide-react';
import './AdminUserSelector.css'; // Crearemos su CSS abajo

const AdminUserSelector = ({ users, selectedUser, onChange }) => {
  return (
    <div className="ad-user-selector-wrapper">
      <div className="ad-selector-icon">
        <Users size={18} />
      </div>
      <select 
        className="ad-neumorphic-select"
        value={selectedUser} 
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="global">🌍 Vista Global (Todos)</option>
        <optgroup label="Alumnos Individuales">
          {users.map(user => (
            <option key={user.id} value={user.id}>
              👤 {user.alias || user.name}
            </option>
          ))}
        </optgroup>
      </select>
    </div>
  );
};

export default AdminUserSelector;